import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { eventBus } from '../../../../main';
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_SET_SEARCH_PARAMS } from '../../../../store/service-book';
import { IServiceBookDetails, IServiceBookSearchParams } from '../../../../store/service-book/service-book-state.store';

interface IMenuItem {
  text:string
  totalKey:string|null
  path:string}


const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)
@Component({
  name:'BookServiceSidebarDetails',
  components: {
  }
})
class BookServiceSidebarDetails extends Vue {

  @ServiceBookStore.Getter currentServiceBook:IServiceBookDetails

  constructor() {
    super();

  }



  get lblSetting(): { [prop: string]: string } {
    return {
      ...require('@/locales/service-book').default
    }
  }

  get menus():IMenuItem[] {
    return [
      {
        text:'Informations générales',
        totalKey:null,
        path:`/service-book/${this.$route.params.id}`
      },
      {
        text:'Demandes en cours',
        totalKey:'totalTickets',
        path:`/service-book/${this.$route.params.id}/tickets`
      },
      /* {
        text:'Contacts',
        totalKey:'totalContacts',
        path:`/service-book/${this.$route.params.id}/contacts`
      }, */
      {
        text:'Documents associés',
        totalKey:'totalDocuments',
        path:`/service-book/${this.$route.params.id}/documents`
      },
      {
        text:'Équipements',
        totalKey:'totalEquipments',
        path:`/service-book/${this.$route.params.id}/equipments`
      },
      {
        text:'Maintenances',
        totalKey:'totalMaintenances',
        path:`/service-book/${this.$route.params.id}/maintenances`
      }
    ]
  }

  getTotal(item:IMenuItem)
  {
    if(!item.totalKey) return null
    return `(${this.currentServiceBook[item.totalKey]})`
  }

}

export default BookServiceSidebarDetails;



// WEBPACK FOOTER //
// ./src/containers/service-book/components/sidebarDetails/index.ts